import { ConfirmationModal } from "shared/components/pillar-modal/NewConfirmationModal";
import { useHubCheckoutContext } from "hub/src/pages/checkout/context/HubCheckoutContext";
import { useHubCheckoutInvoiceItemContext } from "hub/src/pages/checkout/context/HubCheckoutInvoiceItemContext";

export const HubCheckoutDeleteInvoiceItemModal = () => {
  const {
    invoiceItem,
    deleteInvoiceItemModalOpen,
    setDeleteInvoiceItemModalOpen,
  } = useHubCheckoutInvoiceItemContext();
  const { handleUpdateInvoice } = useHubCheckoutContext();

  return (
    <ConfirmationModal
      actionName="Remove Item"
      title="Remove Item"
      testid={`admin-delete-invoice-item-${invoiceItem.invoiceItemId}`}
      approveAction={async () => {
        await handleUpdateInvoice({
          deleteInvoiceItems: [{ invoiceItemId: invoiceItem.invoiceItemId }],
        });
      }}
      control={{
        isOpen: deleteInvoiceItemModalOpen,
        onClose: async () => setDeleteInvoiceItemModalOpen(null),
        setIsOpen: (open) =>
          setDeleteInvoiceItemModalOpen(open ? invoiceItem : null),
      }}
    >
      <div className="pb-3 -mt-2">
        Are you sure you want to remove {invoiceItem.productName} from the
        invoice?
      </div>
    </ConfirmationModal>
  );
};
